import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePostOwnerSupplierManagerParams, TypePostOwnerSupplierManagerResponse } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 공급사 관리] 담당자 정보 등록
 */
const usePostOwnerSupplierManager = () => {
  const endPoint = '/api-owner/owner-supplier-manager';

  const postOwnerSupplierManager = async (params: TypePostOwnerSupplierManagerParams) => {
    return axiosInstance
      .post<TypePostOwnerSupplierManagerResponse>(endPoint, params)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { postOwnerSupplierManager };
};

export default usePostOwnerSupplierManager;
